import TasksDetails from "page_components/webmaster/tasks/Details";
import TaskProvider from "context/webmaster/task";
import TasksProvider from "context/webmaster/tasks";

const TaskDetails = () => {
  return (
    <TasksProvider>
      <TaskProvider>
        <TasksDetails />
      </TaskProvider>
    </TasksProvider>
  );
};

export default TaskDetails;
